import { AsyncReturnType } from "type-fest";

import { ConnectionService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof ConnectionService.linkLinkedInAccount>[0];
type Data = AsyncReturnType<typeof ConnectionService.linkLinkedInAccount>;
type Error = unknown;

export const useLinkLinkedInAccount = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    ConnectionService.linkLinkedInAccount,
    options
  );

  return result;
};
